/**
 * IconButton component.
 */
import Button from '@components/atoms/buttons/genericButton';
import Props from '@shared/types/props/pressable';
import useButton from '../lib/useButton';

/**
 * Displays the icon button with the given text and action.
 * Handles the default button actions such as focus, enabled, list index, and list focused.
 */
export default function IconButton(
  parentProps: Props & {
    Icon?: ({ focused }: { focused: boolean }) => JSX.Element | null;
  }
) {
  const { Icon } = parentProps;
  const { callbacks, props, buttonText } = useButton({
    ...parentProps,
  });
  return (
    <Button {...props} {...callbacks} id='iconButton'>
      {Icon ? <Icon focused={props.displayIcon} /> : null}
      <span style={{ marginLeft: 8 }}>{buttonText}</span>
    </Button>
  );
}
